import React from 'react';
import { FilterKeyTitleAndExclusion, FilterKeys, Filters, FilterTitle, Option } from '@utils/pageConfig/Types';
import FilterSelector from '../filter-component/FilterSelector';

interface Props {
  brandFilter: Filters;
  selectedBrands: Option[];
  onBrandsChangeFunc: (toUpdate: Filters) => void;
  isLoadingBrands: boolean;
  isVirtualBrandList: boolean;
}

const brandFilterKeyAndTitle: FilterKeyTitleAndExclusion = {
  filterKey: FilterKeys.BRAND,
  filterTitle: FilterTitle.BRAND,
};

const BrandSelector: React.FC<Props> = ({
  brandFilter,
  selectedBrands,
  onBrandsChangeFunc,
  isLoadingBrands,
  isVirtualBrandList,
}) => {
  const maxBrandsLength = 10;

  const updatedOptions = brandFilter?.options.map((option) =>
    selectedBrands.length >= maxBrandsLength && !selectedBrands.some((v) => option.value === v.value)
      ? { ...option, isDisabled: true }
      : option,
  );

  return (
    <div
      key={`${isLoadingBrands}-${brandFilterKeyAndTitle}-${updatedOptions}`} //NOSONAR typescript:S6551
      id="brand-filter-selector"
      data-testid="brand-filter-selector"
      style={{ minWidth: '200px' }}
    >
      <FilterSelector
        selectFilter={brandFilterKeyAndTitle}
        placeholder={'All'}
        options={updatedOptions ?? []}
        value={selectedBrands ?? []}
        disableSelectorPredicate={() => isLoadingBrands}
        isVirtualList={isVirtualBrandList}
        onChangeFunc={onBrandsChangeFunc}
      />
    </div>
  );
};

export default BrandSelector;
